module.exports = __webpack_public_path__ + "3b87640180123633ca67c2cdf8ca52ce.svg";